"use strict";
exports.__esModule = true;
function getChartOptions(graph, options) {
    var _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends;
    var mainRows = graph.mainRows, siblingRows = graph.siblingRows, xBuckets = graph.xBuckets, isCounts = graph.isCounts;
    var buckets = JSON.parse(xBuckets);
    var xCategory = buckets.map(function (b) { return b.Name; });
    var series = legends.map(function (_a) {
        var tag = _a.tag, color = _a.color;
        return {
            color: color,
            name: tag,
            data: putItemsInBuckets(mainRows, buckets, isCounts)
        };
    });
    if (siblingRows && siblingRows.length) {
        var sl = siblingLegends[0];
        series.push({
            color: sl.color,
            name: sl.tag,
            data: putItemsInBuckets(siblingRows, buckets, isCounts)
        });
    }
    return generateChartOptions(graph, options, xCategory, series, isCounts);
}
exports.getChartOptions = getChartOptions;
function putItemsInBuckets(items, buckets, isCount) {
    var totalItemsCount = items.length;
    return buckets.map(function (b) {
        var GE = b.GE, LT = b.LT;
        var lowerBound = isNaN(Number(GE)) ? Number.MIN_SAFE_INTEGER : Number(GE);
        var upperBound = isNaN(Number(LT)) ? Number.MAX_SAFE_INTEGER : Number(LT);
        var count = items.filter(function (item) { return item.x >= lowerBound && item.x < upperBound; }).length;
        return isCount ? count : count / totalItemsCount;
    });
}
function generateChartOptions(graph, options, xCategory, series, isCounts) {
    var chartTitle = options.chartTitle, settings = options.settings, timestamp = options.timestamp;
    var formatFunc = isCounts ?
        function (val) { return val.toFixed(0); } :
        function (val) { return (val * 100).toFixed(0) + '%'; };
    return {
        chart: {
            renderTo: 'chartContainer',
            type: 'column',
            // height: 560,
            // width: 580,
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            categories: xCategory,
            crosshair: true
        },
        yAxis: [{
                min: 0,
                title: {
                    text: graph.yTitle
                },
                labels: {
                    formatter: function () {
                        return formatFunc(this.value);
                    }
                }
            }],
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                return "<b>" + this.key + "</b><br /><i>" + this.series.name + "</i>: " + formatFunc(this.y);
            }
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    crop: false,
                    overflow: 'none',
                    formatter: function () {
                        return formatFunc(this.y);
                    }
                }
            }
        },
        series: series
    };
}
function getAdditionalChartCallback() {
}
exports.getAdditionalChartCallback = getAdditionalChartCallback;
//# sourceMappingURL=bucket-chart.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/bucket-chart2/bucket-chart.chart.js